module.exports = {
  plugins: [
    ({ addUtilities }) => {
      addUtilities({
        ".appContainer": {
          padding: "0px calc(100% - 90%)",
          margin: "0px auto",
          "max-width": "100%",
          "@screen lg": {
            padding: "0px calc(100% - 95%)"
          }
        },
        ".btn": {
          "@apply bg-theme-primary text-white rounded-[4px] px-8 py-4": {},
          "&-text": {
            "@apply bg-none hover:text-theme-primary text-theme-primary underline": {}
          },
          "&-outline": {
            "@apply text-theme-primary bg-none border border-theme-primary px-8 py-3": {}
          },
          "&:disabled": {
            "@apply opacity-40 cursor-default": {},
          },
        }
      })
    }
  ]
};